import React from "react";
import { ViewsListWrap } from "./ViewsListWrap";

const ViewsReactView = () => {
  return <ViewsListWrap />;
};
window.ViewsReactView = ViewsReactView;
